import { MONTH_MAPPER } from '../constants/dateTime'

export function isDuringSchool(date: Date): boolean {
  const day = date.getDay()
  const time = date.getHours()
  const isWeekday = day !== 6 && day !== 0
  const isSchoolHours = time >= 8 && time < 15
  return isWeekday && isSchoolHours
}

export function toEndOfSchoolDay(date: Date): Date {
  date.setHours(15, 0, 0, 0)
  return date
}

export const getCurrentTime = () => Math.round(new Date().getTime() / 1000)

export const getCurrentTimeString = () => new Date().toString()

export const getDateHourDiff = (date1: string, date2: string) =>
  Math.abs(Date.parse(date1) - Date.parse(date2)) / 36e5

export const getMappedMonth = (month: any): string => {
  let mappedMonth: string
  if (month && Number.isNaN(parseInt(month, 10))) {
    mappedMonth = month.toLowerCase()
  } else {
    mappedMonth = month && MONTH_MAPPER[`0${month - 1}`.slice(-2)]
  }
  return mappedMonth
}
